import type {
  GbpKpi,
  GbpNextPost,
  GbpOfferSync,
  GbpPhotoFreshness,
  GbpPost,
  GbpProfileItem,
  GbpQa,
  GbpReview,
  GbpReviewSnapshot,
} from './types';

export const GBP_KPIS: GbpKpi[] = [
  {
    key: 'pending',
    label: 'Pending Review Responses',
    value: '4',
    sub: 'ELVA drafted — awaiting your approval',
    tone: 'terra',
  },
  {
    key: 'response-rate',
    label: 'Response Rate',
    value: '87%',
    sub: '13 of 15 reviews responded (last 30 days)',
    tone: 'teal',
  },
  {
    key: 'posts',
    label: 'GBP Posts This Month',
    value: '3',
    sub: 'Target: 4/month (1 per week)',
    tone: 'neutral',
  },
  {
    key: 'qa',
    label: 'Q&As Answered',
    value: '4 / 6',
    sub: '2 pending your approval',
    tone: 'neutral',
  },
  {
    key: 'completeness',
    label: 'Profile Completeness',
    value: '60%',
    sub: '6 of 10 fields complete',
    tone: 'gold',
  },
];

export const GBP_REVIEWS: GbpReview[] = [
  {
    id: 1,
    reviewer: 'Sarah M.',
    rating: 'FIVE',
    text: 'Dr. Chen is amazing! I was terrified of getting my wisdom teeth out but he made the whole experience so comfortable. The staff was incredibly kind and the follow-up care was excellent. Highly recommend!',
    date: '2 hours ago',
    draft: "Thank you so much, Sarah! We're thrilled to hear Dr. Chen made your experience comfortable — that's always our priority. We really appreciate you trusting us with your care. See you at your next visit!",
    status: 'pending',
  },
  {
    id: 2,
    reviewer: 'Mike R.',
    rating: 'ONE',
    text: "Waited 45 minutes past my appointment time. No apology from the front desk. The actual dental work was fine but the disrespect for my time is unacceptable. Won't be returning.",
    date: '5 hours ago',
    draft: "Mike, thank you for sharing this feedback. We sincerely apologize for the wait — we understand how valuable your time is, and that's not the experience we want for any patient. We'd love the chance to make this right. Please call us directly at (905) 555-0123 so we can discuss this personally.",
    status: 'pending',
  },
  {
    id: 3,
    reviewer: 'Priya K.',
    rating: 'FOUR',
    text: 'Great office and friendly staff. Only reason for 4 stars instead of 5 is that the parking situation is really difficult. But the dental care itself is top notch.',
    date: '1 day ago',
    draft: "Thank you, Priya! We're glad you had a great experience with our team. We hear you on parking — we know it can be tricky. Pro tip: there's a free municipal lot behind the building on Oak Street, just a 1-minute walk! Hope that helps for your next visit.",
    status: 'pending',
  },
  {
    id: 4,
    reviewer: 'James L.',
    rating: 'FIVE',
    text: "Best dental experience I've ever had. Period.",
    date: '2 days ago',
    draft: 'Wow, James — that means the world to us! Thank you for those kind words. We look forward to keeping that streak going. See you next time!',
    status: 'pending',
  },
];

export const GBP_POSTS: GbpPost[] = [
  {
    id: 1,
    type: 'Article Promotion',
    title: 'New: How Much Do Dental Implants Cost in Brampton?',
    status: 'Scheduled',
    date: 'Thu, Apr 16',
    tone: 'teal',
  },
  {
    id: 2,
    type: 'Offer',
    title: 'Spring Whitening Special — $199 Professional Whitening',
    status: 'Live',
    date: 'Apr 10 – May 31',
    tone: 'success',
  },
  {
    id: 3,
    type: 'Team Highlight',
    title: 'Meet Dr. Sarah Chen — Lead Implant Surgeon',
    status: 'Published',
    date: 'Apr 3',
    tone: 'neutral',
  },
  {
    id: 4,
    type: 'Seasonal',
    title: "Don't Lose Your 2026 Dental Benefits!",
    status: 'Published',
    date: 'Mar 27',
    tone: 'gold',
  },
  {
    id: 5,
    type: 'Milestone',
    title: 'Thank You Brampton! 200 Five-Star Reviews!',
    status: 'Published',
    date: 'Mar 20',
    tone: 'success',
  },
];

export const GBP_NEXT_POST: GbpNextPost = {
  title: 'Next Scheduled Post — Thursday, Apr 16',
  body: 'ELVA will promote your new blog article "How Much Do Dental Implants Cost in Brampton?" as a GBP Update post. The post will include a "Learn More" button linking to the article.',
  footnote: 'Auto-publishing is enabled for GBP posts. You can disable this in Settings → Autopilot Rules.',
};

export const GBP_QAS: GbpQa[] = [
  {
    id: 1,
    q: 'Do you accept walk-in patients?',
    a: 'Yes! We welcome walk-ins and always try to accommodate same-day visits. For the shortest wait, we recommend booking online or calling ahead at (905) 555-0123.',
    status: 'Posted',
    category: 'Logistics',
  },
  {
    id: 2,
    q: 'What insurance plans do you accept?',
    a: "We accept most major insurance plans including Sun Life, Great-West Life, Manulife, Blue Cross, and many more. Call us to verify your specific plan — we'll handle the paperwork for you.",
    status: 'Posted',
    category: 'Insurance',
  },
  {
    id: 3,
    q: 'Do you offer sedation for nervous patients?',
    a: 'Absolutely. We offer both nitrous oxide (laughing gas) and oral sedation for anxious patients. Dr. Chen has helped hundreds of patients overcome dental anxiety.',
    status: 'Posted',
    category: 'Services',
  },
  {
    id: 4,
    q: 'Do you offer payment plans?',
    a: 'Yes, we offer flexible financing through PayBright with 0% interest for up to 12 months. No patient should delay care because of cost.',
    status: 'Posted',
    category: 'Financial',
  },
  {
    id: 5,
    q: 'How much do dental implants cost?',
    a: "Dental implants at our Brampton office start at $3,200 per tooth. We offer free consultations and financing options. Every case is different, so we'll create a personalized treatment plan.",
    status: 'Pending',
    category: 'Services',
  },
  {
    id: 6,
    q: 'Do you see children? What age?',
    a: 'We love our young patients! We see children starting at age 3 for their first dental visit. Dr. Patel specializes in pediatric dentistry and makes every child feel at ease.',
    status: 'Pending',
    category: 'Services',
  },
];

export const GBP_PROFILE_ITEMS: GbpProfileItem[] = [
  { field: 'Business Description', complete: true, priority: 'Critical' },
  { field: 'Service List', complete: true, priority: 'Critical' },
  { field: 'Office Hours', complete: true, priority: 'Critical' },
  { field: 'Phone & Website', complete: true, priority: 'Critical' },
  { field: 'Appointment Link', complete: true, priority: 'High' },
  { field: 'Insurance List', complete: false, priority: 'High' },
  { field: 'Photos (last 90 days)', complete: false, priority: 'Medium' },
  { field: 'Active Posts/Offers', complete: true, priority: 'Medium' },
  { field: 'Q&A Section (5+ answers)', complete: false, priority: 'Medium' },
  { field: 'Spanish Description', complete: false, priority: 'Low' },
];

export const GBP_OFFER_SYNC: GbpOfferSync = {
  status: 'Synced',
  offer: 'Spring Whitening Special — $199',
  body: 'is live on both Google Ads and your GBP listing.',
  footnote:
    "Offers auto-sync daily at 7 AM. When an offer expires in Google Ads, it's automatically removed from GBP.",
};

export const GBP_PHOTO_FRESHNESS: GbpPhotoFreshness = {
  daysSinceUpload: 73,
  progressPct: 81,
  body: 'Smile Central uploaded 15 photos last month. Listings with recent photos get 42% more direction requests. Upload 3-5 photos of your team, waiting area, or operatories.',
  totalPhotos: 23,
  competitorAvg: 41,
};

export const GBP_REVIEW_SNAPSHOT: GbpReviewSnapshot = {
  stats: [
    { key: 'rating', value: '4.6', label: 'Your Rating', tone: 'teal' },
    { key: 'total', value: '187', label: 'Total Reviews', tone: 'neutral' },
    { key: 'last30', value: '+12', label: 'Last 30 Days', tone: 'success' },
  ],
  body: "You're adding reviews faster than Smile Central (+8) but slower than Bright Smiles (+18). Avg response time: 4.2 hours.",
};
